import React, { memo } from 'react';

export type DetailBreadCrumbPartialProps = {
  title: string;
};

const BreadCrumbPartial = ({ title }: DetailBreadCrumbPartialProps) => {
  return (
    <div className="tw-flex tw-gap-x-2 tw-items-center tw-font-normal tw-text-base !tw-text-secondary-70">
      Trực tiếp &nbsp;
      {' > '}&nbsp;
      <span className="tw-line-clamp-1 tw-flex-1">{title}</span>
    </div>
  );
};

export default memo(BreadCrumbPartial);
